export default __webpack_public_path__ + "static/media/avatar-8.029f0574.jpg";